import { Box } from "@mui/material";
import LockScreen from "../../LockScreen/LockScreen";

const LockScenario = () => {
    return (
        <Box>
            <LockScreen />
        </Box>
    );
};

export default LockScenario;
